import React, { useEffect, useState } from "react";
import { BsArrowRight } from "react-icons/bs";
import { Carousel, CarouselItem } from "react-bootstrap";
import "../assets/custom_styles.css";
import Cancer_Today from "../assets/img/Cancer_Today.png";
import Cancer_Tomorrow from "../assets/img/Cancer_Tomorrow.png";
import Cancer_Overtime from "../assets/img/Cancer_Overtime.png";
import Initiatives_img1 from "../assets/img/Initiatives_img1.png";
import Initiatives_img2 from "../assets/img/Initiatives_img2.png";
import Initiatives_img3 from "../assets/img/Initiatives_img3.png";
// import icon1 from "../assets/img/Icon_1.png";
// import icon2 from "../assets/img/Icon_2.png";
// import icon3 from "../assets/img/Icon_3.png";

import { useNavigate, Link } from "react-router-dom";
import axios from "axios";

const Content = () => {
  const [selectedType, setSelectedType] = useState("");
  const navigate = useNavigate();
  useEffect(() => {
    const storedType = JSON.parse(sessionStorage.getItem("visual_type"));
    if (storedType) {
      setSelectedType(storedType);
    } else {
      //Default to today visual type if no selection
      setSelectedType("today");
      sessionStorage.setItem("visual_type", JSON.stringify("today"));
    }
  }, []);

  const handleVisualType = (type) => {
    sessionStorage.setItem("visual_type", JSON.stringify(type));
    setSelectedType(type);

    if (type === "today") {
      navigate("/Visualization");
    } else if (type === "tomorrow") {
      navigate("/CancerTomorrow");
    } else {
      navigate("/CancerOvertime");
    }
  };

  const getStyles = (type) => ({
    backgroundColor: selectedType === type ? "#007bff" : "transparent", // Blue or transparent
    color: selectedType === type ? "black" : "white",
  });

  const getImageStyle = (type) => ({
    filter:
      selectedType === type
        ? "brightness(0) saturate(100%) invert(27%) sepia(98%) saturate(2765%) hue-rotate(204deg) brightness(95%) contrast(101%)"
        : "none",
  });

  const [banners, setBanners] = useState([]);
  // const [loading, setloading] = useState(false);
  useEffect(() => {
    axios
      .post("fetch_bannerdetails")
      .then((response) => {
        setBanners(response.data.data);
      })
      .catch((error) => {});
  }, []);
  // if (!Array.isArray(banners) || banners.length === 0) return;
  //  setloading(true);
  // Helper to check login and redirect for dynamic banner links
  const handleBannerLearnMore = (name, url) => {
    const token = sessionStorage.getItem("token");

    // Define banner names and corresponding routes
    const bannerNames = {
      "Recent Cancer Statistics": "/Visualization",
      "Trend of Cancer Incidence": "/CancerOvertime",
      "Cancer Projection": "/CancerTomorrow",
    };

    // Check if the name matches any of the banner names
    if (bannerNames[name]) {
      if (!token) {
        // Set the visual type in sessionStorage if not logged in
        const visualTypes = {
          "Recent Cancer Statistics": "today",
          "Trend of Cancer Incidence": "overtime",
          "Cancer Projection": "tomorrow",
        };

        sessionStorage.setItem(
          "visual_type",
          JSON.stringify(visualTypes[name]),
        );

        // Redirect to login page
        navigate("/login");
        return; // exit function after navigating
      } else {
        // User is logged in, navigate to the corresponding page
        const visualTypes = {
          "Recent Cancer Statistics": "today",
          "Trend of Cancer Incidence": "overtime",
          "Cancer Projection": "tomorrow",
        };

        sessionStorage.setItem(
          "visual_type",
          JSON.stringify(visualTypes[name]),
        );
        navigate(bannerNames[name]);
        return; // exit function after navigating
      }
    }

    // If url is absolute (starts with http), use window.location.href
    if (/^https?:\/\//i.test(url)) {
      window.location.href = url;
    } else {
      navigate(url);
    }
  };

  return (
    <main>
      <div className="container-fluid px-0">
        {/* Banner Carousel Section */}
        {/* <div className="banner-section"> */}
        <Carousel indicators={true} controls={true}>
          {banners.map((banner, index) => (
            <CarouselItem key={index}>
              <div className="container my-3 my-md-4">
                <div className="row align-items-center banner-row">
                  <div className="col-12 col-md-6 banner-text-col mb-3 mb-md-0">
                    <div className="banner-content">
                      <h3 className="mb-3 text-primary banner-title">
                        {banner.banner_name}
                      </h3>
                      <div className="text-grey pb-3 lh-lg banner-text fs-6">
                        {(() => {
                          const lines = banner.banner_content.split("\n");
                          const elements = [];
                          let bullets = [];

                          lines.forEach((line, idx) => {
                            const trimmed = line.trim();
                            if (!trimmed) return;

                            if (trimmed.startsWith("•")) {
                              bullets.push(trimmed.replace("•", "").trim());
                            } else {
                              if (bullets.length) {
                                elements.push(
                                  <ul
                                    key={`ul-${idx}`}
                                    style={{
                                      paddingLeft: "20px",
                                      margin: 0,
                                      listStylePosition: "inside",
                                    }}
                                  >
                                    {bullets.map((item, i) => (
                                      <li key={i}>{item}</li>
                                    ))}
                                  </ul>,
                                );
                                bullets = [];
                              }
                              elements.push(
                                <div key={`div-${idx}`}>{trimmed}</div>,
                              );
                            }
                          });

                          if (bullets.length) {
                            elements.push(
                              <ul
                                key="ul-end"
                                style={{
                                  paddingLeft: "20px",
                                  margin: 0,
                                  listStylePosition: "inside",
                                }}
                              >
                                {bullets.map((item, i) => (
                                  <li key={i}>{item}</li>
                                ))}
                              </ul>,
                            );
                          }

                          return elements;
                        })()}
                      </div>

                      {banner.video_url && (
                        <div>
                          <button
                            type="button"
                            className="btn btn-primary btn-sm fs-6"
                            onClick={() =>
                              handleBannerLearnMore(
                                banner.banner_name,
                                banner.video_url,
                              )
                            }
                          >
                            Learn More <BsArrowRight size={20} />
                          </button>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="col-12 col-md-6 banner-img-col">
                    <img
                      src={banner.banner_image}
                      className="hero_img"
                      alt={banner.banner_name}
                    />
                  </div>
                </div>
              </div>
            </CarouselItem>
          ))}
        </Carousel>
        {/* </div> */}

        {/* Data Visualization Cards Section */}
        <div className="container my-4 my-md-5">
          <div className="row justify-content-center">
            <div className="col-12">
              <div className="viz-cards-wrapper shadow p-3 p-md-4 mb-5 bg-white rounded-3">
                <div className="row g-2 g-md-3">
                  <div className="col-12 col-sm-6 col-lg-4">
                    <div
                      className={`viz-card p-3 rounded-3 ${
                        selectedType === "today"
                          ? "bg-shade-blue"
                          : "bg-shade-grey"
                      }`}
                    >
                      <div className="d-flex flex-column align-items-center justify-content-center">
                        <img
                          src={Cancer_Today}
                          alt="Cancer_Today"
                          className="viz-icon"
                          style={getImageStyle("today")}
                          onClick={() => handleVisualType("today")}
                        />
                        <button
                          className="mt-3 mb-0 fs-6 fw-bold text-black border-0 bg-transparent"
                          style={getStyles("today")}
                          onClick={() => handleVisualType("today")}
                        >
                          Recent Cancer Statistics
                        </button>
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-sm-6 col-lg-4">
                    <div
                      className={`viz-card p-3 rounded-3 ${
                        selectedType === "overtime"
                          ? "bg-shade-blue"
                          : "bg-shade-grey"
                      }`}
                    >
                      <div className="d-flex flex-column align-items-center justify-content-center">
                        <img
                          src={Cancer_Overtime}
                          alt="Cancer_Overtime"
                          className="viz-icon"
                          style={getImageStyle("overtime")}
                          onClick={() => handleVisualType("overtime")}
                        />
                        <button
                          className="mt-3 mb-0 fs-6 fw-bold text-black border-0 bg-transparent"
                          onClick={() => handleVisualType("overtime")}
                          style={getStyles("overtime")}
                        >
                          Trend of Cancer Incidence
                        </button>
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-sm-6 col-lg-4 mx-auto mx-lg-0">
                    <div
                      className={`viz-card p-3 rounded-3 ${
                        selectedType === "tomorrow"
                          ? "bg-shade-blue"
                          : "bg-shade-grey"
                      }`}
                    >
                      <div className="d-flex flex-column align-items-center justify-content-center">
                        <img
                          src={Cancer_Tomorrow}
                          alt="Cancer_Tomorrow"
                          className="viz-icon"
                          style={getImageStyle("tomorrow")}
                          onClick={() => handleVisualType("tomorrow")}
                        />
                        <button
                          className="mt-3 mb-0 fs-6 fw-bold text-black border-0 bg-transparent"
                          onClick={() => handleVisualType("tomorrow")}
                          style={getStyles("tomorrow")}
                        >
                          Cancer Projection
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Initiatives Section */}
        <div className="container my-4 my-md-5">
          <div className="initiatives-section">
            <h3 className="text-center text-primary mb-4 initiatives-title">
              Initiatives and Databases
            </h3>
            <div className="row g-3 g-md-4">
              <div className="col-12 col-md-6 col-lg-4">
                <div className="initiative-card shadow p-4 bg-white rounded-3 h-100">
                  <img
                    className="pb-3 initiative-img"
                    src={Initiatives_img1}
                    alt="Initiatives_img1"
                  />
                  <h6 className="text-decoration-underline mb-3 initiative-card-title">
                    Tamil Nadu Cancer Registry Program (TNCRP)
                  </h6>
                  <p className="lh-lg fs-6 initiative-card-text">
                    A state-level cancer registry based surveillance study
                    initiated by the Cancer Institute (WIA), Adyar, Chennai in
                    collaboration with the department of health and family
                    welfare...
                  </p>
                  <div className="mt-auto">
                    <a
                      href="https://tncrp.cancerinstitutewia.in/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-primary btn-sm fs-6"
                    >
                      Learn More <BsArrowRight size={20} />
                    </a>
                  </div>
                </div>
              </div>

              <div className="col-12 col-md-6 col-lg-4">
                <div className="initiative-card shadow p-4 bg-white rounded-3 h-100">
                  <img
                    className="pb-3 initiative-img"
                    src={Initiatives_img2}
                    alt="Initiatives_img2"
                  />
                  <h6 className="text-decoration-underline mb-3 initiative-card-title">
                    TN-CReSt Database
                  </h6>
                  <p className="lh-lg fs-6 initiative-card-text">
                    Incidence statistics by populations/ cancers since 2012
                    Trend of cancers 2012-2023 Projected cancers 2024-2030 Age @
                    diagnosis Gender Incidence year Residence district...
                  </p>
                  <div className="mt-auto">
                    <Link
                      to="/Visualization"
                      className="btn btn-primary btn-sm fs-6"
                    >
                      Learn More <BsArrowRight size={20} />
                    </Link>
                  </div>
                </div>
              </div>

              <div className="col-12 col-md-6 col-lg-4 mx-auto mx-md-0">
                <div className="initiative-card shadow p-4 bg-white rounded-3 h-100">
                  <img
                    className="pb-3 initiative-img"
                    src={Initiatives_img3}
                    alt="Initiatives_img3"
                  />
                  <h6 className="text-decoration-underline mb-3 initiative-card-title">
                    Cancer Institute (W.I.A)
                  </h6>
                  <p className="lh-lg fs-6 initiative-card-text">
                    A non-government, not-for-profit, charitable institution for
                    cancer diagnostics, treatment, education, prevention and
                    research A State Cancer Institute...
                  </p>
                  <div className="mt-auto">
                    <a
                      href="https://cancerinstitutewia.in/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-primary btn-sm fs-6"
                    >
                      Learn More <BsArrowRight size={20} />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};
export default Content;
